module.exports = __webpack_public_path__ + "img/banner.3db22fff.svg";